import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { m365SetupInstructions } from "../../utils/constants";

/**
 * Microsoft Entra setup steps 1–4 (excludes step 5 – grant API permissions, shown after save).
 * Matches AddIntegrationModal pre-save accordion content.
 */
const M365PreSaveInstructionsInner: React.FC = () => (
  <Box sx={{ mt: 1.5, p: 2, bgcolor: "#f9f9f9", borderRadius: 1 }}>
    {m365SetupInstructions
      .filter((s) => s.step !== 5)
      .map(({ step, title, steps }) => (
        <Box key={step} sx={{ mb: 2 }}>
          <Typography
            sx={{
              fontFamily: "var(--theo-font-sans)",
              fontWeight: 600,
              fontSize: 14,
              color: "#1a1a1a",
              mb: 1,
            }}
          >
            {step}. {title}
          </Typography>
          <Box sx={{ m: 0, pl: 2.5 }}>
            {steps.map((s, i) => {
              if (typeof s === "object" && "heading" in s) {
                return (
                  <Typography
                    key={i}
                    sx={{
                      fontFamily: "var(--theo-font-sans)",
                      fontSize: 13,
                      color: "#555",
                      lineHeight: 1.5,
                      mb: 1,
                    }}
                  >
                    {s.heading}
                  </Typography>
                );
              }
              if (typeof s === "object" && "numbered" in s) {
                const numberedItems = steps.filter(
                  (x): x is { numbered: string } =>
                    typeof x === "object" && "numbered" in x
                );
                if (numberedItems.indexOf(s) > 0) return null;
                return (
                  <Box
                    key={i}
                    component="ol"
                    sx={{ m: 0, pl: 2.5, "& li": { mb: 0.5 } }}
                  >
                    {numberedItems.map((item, j) => (
                      <Typography
                        key={j}
                        component="li"
                        sx={{
                          fontFamily: "var(--theo-font-sans)",
                          fontSize: 13,
                          color: "#555",
                          lineHeight: 1.5,
                        }}
                      >
                        {item.numbered}
                      </Typography>
                    ))}
                  </Box>
                );
              }
              const bulletItems = steps.filter(
                (x) => typeof x === "string" || (typeof x === "object" && "before" in x)
              );
              const bulletIndex = bulletItems.findIndex((item) => {
                if (item === s) return true;
                if (
                  typeof item === "object" &&
                  typeof s === "object" &&
                  "before" in item &&
                  "before" in s
                ) {
                  return item.before === s.before;
                }
                return false;
              });
              if (bulletIndex > 0) return null;
              if (bulletItems.length > 0) {
                return (
                  <Box
                    key={i}
                    component="ul"
                    sx={{ m: 0, pl: 2.5, "& li": { mb: 0.5 } }}
                  >
                    {bulletItems.map((item, j) => (
                      <Typography
                        key={j}
                        component="li"
                        sx={{
                          fontFamily: "var(--theo-font-sans)",
                          fontSize: 13,
                          color: "#555",
                          lineHeight: 1.5,
                        }}
                      >
                        {typeof item === "string" ? (
                          item
                        ) : "before" in item ? (
                          <>
                            {item.before}
                            <Link
                              href={item.linkUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{ color: "#705d4a", fontWeight: 500 }}
                            >
                              {item.linkText}
                            </Link>
                            {item.after}
                          </>
                        ) : null}
                      </Typography>
                    ))}
                  </Box>
                );
              }
              return null;
            })}
          </Box>
        </Box>
      ))}
  </Box>
);

export default M365PreSaveInstructionsInner;
